<template>
  <div
    class="announcements-banner"
  >
    <Announcement
      v-for="announcement in displayedAnnouncements"
      :key="announcement.id"
      :announcement="announcement"
    />
  </div>
</template>

<script>
/**
 * A banner used to display a message to all clients remotely
 */
// Vuex
import { mapState, mapGetters } from 'vuex';
import { FETCH_ANNOUNCEMENTS } from '@/store/action-types';
import { GET_ANNOUNCEMENTS } from '@/store/mutation-types';
// Components
import Announcement from '@/components/announcement.vue';

export default {
  name: 'AnnouncementsBanner',
  components: {
    Announcement,
  },
  data() {
    return {
      refreshInterval: null,
    };
  },
  computed: {
    ...mapGetters([
      'displayedAnnouncements',
    ]),
    ...mapState({
      announcementsLoading: state => state[GET_ANNOUNCEMENTS.loadingKey],
    }),
  },
  created() {
    this.refresh();
    // Refresh every hour
    this.refreshInterval = setInterval(this.refresh, 3600000);
  },
  destroyed() {
    clearInterval(this.refreshInterval);
  },
  methods: {
    refresh() {
      if (!this.announcementsLoading && this.currentTeam) {
        this.$store.dispatch(FETCH_ANNOUNCEMENTS);
      }
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.announcements-banner {
  box-shadow: 0px 0px 5px #888;
  position: fixed;
  top: $header-height;
  left: $nav-width;
  background: white;
  width: calc(100% - #{$nav-width});
}

@media (max-width: $smartphone-landscape) {
  .announcements-banner {
    top: $smartphone-header-height;
    left: $smartphone-nav-width;
    width: calc(100% - #{$smartphone-nav-width});
  }
}
</style>
